import {
	ADMINGETRISKRULEMAPPING_SUCCESS,
	ADMINGETRISKRULEMAPPING_FAILED,
	RESET_ADMINGETRISKRULEMAPPING,
	LOADING_ADMINGETRISKRULEMAPPING,
	NETWORK_ERROR_ADMINGETRISKRULEMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetadminGetRiskRuleMapping = () => {
	return { type: RESET_ADMINGETRISKRULEMAPPING };
};

const adminGetRiskRuleMapping = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETRISKRULEMAPPING });
	await adminServices
		.post("getRiskRuleMappingList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetRiskRuleMappingsuccess(res.data));
					break;
				default:
					dispatch(adminGetRiskRuleMappingFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETRISKRULEMAPPING,
				payload: err
			});
		});
};
function adminGetRiskRuleMappingsuccess(data) {
	return {
		type: ADMINGETRISKRULEMAPPING_SUCCESS,
		payload: data
	};
}
function adminGetRiskRuleMappingFailed(data) {
	return {
		type: ADMINGETRISKRULEMAPPING_FAILED,
		payload: data
	};
}

export { resetadminGetRiskRuleMapping, adminGetRiskRuleMapping };
